import Vue from 'vue'
import Router from 'vue-router'
import Product from '@/components/Product'
import ProductDetail from "@/components/ProductDetail";
import ProductDtu from "@/components/ProductDtu";

import ProductDetailTouch from '@/components/ProductDetailTouch';

import WxSuccess from "@/components/WxSuccess";
import CupSuccess from "@/components/CupSuccess";
import AliSuccess from "@/components/AliSuccess";


Vue.use(Router)

export default new Router({

  routes: [
    {
      path: '/',
      name: 'Product',
      component: Product
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/productdetail',
      name: 'ProductDetail',
      component: ProductDetail
    },
    {
      path: '/productdtu',
      name: 'ProductDtu',
      component: ProductDtu
    },
    {
      path: '/ProductDetailTouch',
      name: 'ProductDetailTouch',
      component: ProductDetailTouch
    },
    {
      path: '/wxsuccess',
      name: 'WxSuccess',
      component: WxSuccess
    },
    {
      path: '/cupsuccess',
      name: 'CupSuccess',
      component: CupSuccess
    },
    {
      path: '/alisuccess',
      name: 'AliSuccess',
      component: AliSuccess
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js